import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextArea } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/TextArea';
/**
 * @class NCTextArea
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCTextArea
 * @label 大文本
 *
 */
class NCTextArea extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title className
         * @description 样式
         */
        className: PropTypes.string,
        /**
         * @title 显示最多字数限制
         * @description 显示最多字数限制
         */
        showMax: PropTypes.bool,
        /**
         * @title 自动化Id
         * @description 自动化Id
         */
        fieldid: PropTypes.string,
        /**
         * @title 最大长度
         * @description 最大长度
         */
        maxlength: PropTypes.number,
        /**
        * @title 检查中文
        * @description 检查中文
        */
        isCheckChinese: PropTypes.bool,
        /**
       * @title 公式编辑器
       * @description 公式编辑器
       */
        isFormularEditor: PropTypes.bool,
        /**
        * @title 调整尺寸
        * @description 调整尺寸
        */
        canResize: PropTypes.bool,

    }
    static getCompMeta = () => {
        return CompMeta;
    }

    static defaultProps = {
        showMax: false,
        canResize: true,
        isCheckChinese: false,

    }

    render() {
        return (
            <TextArea {...this.props} />
        )
    }
}

export default NCTextArea;
